<template>
  <div
    class="flex justify-center"
  >
    <div class="flex flex-col items-center gap-4 sticky bottom-12">
      <slot />
    </div>
  </div>
</template>